// src/sot/primitives/AddChip.jsx
import React from "react";

/**
 * AddChip
 *
 * Blueprint-aligned tonal button for header actions (e.g. "Add").
 * Behaviour mirrors SaveChip:
 * - Disabled: low-contrast tonal background + 40% on-surface text
 * - Enabled: primary tonal background + primary text
 */
export default function AddChip({
  disabled = false,
  onClick,
  children = "Add",
  className = "",
  style,
}) {
  const baseClasses = `
    inline-flex items-center justify-center
    rounded-lg
    px-3 py-1.5
    text-label-large font-medium
    transition-colors duration-150
    focus:outline-none
    focus-visible:ring-2 focus-visible:ring-[rgba(77,163,255,0.45)]
    focus-visible:ring-offset-0
    disabled:cursor-not-allowed
  `;

  const enabledClasses = `
    bg-[rgba(77,163,255,0.12)]
    text-primary
    hover:bg-[rgba(77,163,255,0.18)]
  `;

  const disabledClasses = `
    bg-[rgba(24,50,119,0.06)]
    text-on-surface/40
  `;

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      style={style}
      className={`${baseClasses} ${
        disabled ? disabledClasses : enabledClasses
      } ${className}`}
    >
      {children}
    </button>
  );
}
